/* eslint-disable */
import sysConfig from '@/configs/sys';

const matlsApiUrl = sysConfig.matlsApiUrl;

export default {
  signin(data) {
    return fetch
      .post(`${matlsApiUrl}/token`, {params: data})
      .then(res => res.json());
  },

  validateToken(token) {
    let opt = {
      headers: new Headers({
        'Authorization': token
      })
    };
    return fetch
      .get(`${matlsApiUrl}/JWTTokenIsAuthenticated`, opt)
      .then(res => res.json());
  }
};